module.exports = __webpack_public_path__ + "static/view_2-63c5020c37822bd2c290c05c452b12b7.jpg";